export class PartySuppliers {
    public CN_CRCODE!: Number;
    public CN_CNCODE!: Number;
    public CN_DELI_INST!: string;
    public CN_FRT_MODE!: string;
    public CN_BOXTYPE!: string;
    public CN_BILLPARTY!: number;
    public CREATEDBY_USERID!: Number;
    public UPDATEDBY_USERID!: Number;
    public CREATED_DATE!: Date;
    public UPDATED_DATE!: Date;
}